import Pill from '@/shared/components/flip-ui-kit/Pill';
import { type LiquidationType } from '@/shared/graphql/generated/explorer/graphql';
import BoltIcon from '@/shared/icons/flip-ui-kit/small/Bolt';
import BrokerIcon from '@/shared/icons/flip-ui-kit/small/Broker';
import ChunksIcon from '@/shared/icons/flip-ui-kit/small/Chunks';
import DocIcon from '@/shared/icons/flip-ui-kit/small/Doc';
import FireIcon from '@/shared/icons/flip-ui-kit/small/Fire';
import PercentageIcon from '@/shared/icons/flip-ui-kit/small/Percentage';
import PulseIcon from '@/shared/icons/flip-ui-kit/small/Pulse';
import ShieldTickIcon from '@/shared/icons/flip-ui-kit/small/ShieldTick';
import UsersIcon from '@/shared/icons/flip-ui-kit/small/Users';

type PillProps = {
  maxWidth?: boolean;
};

export const LiquidationPill = (
  props: PillProps & { liquidationType?: LiquidationType | null },
) => {
  let iconColor;
  let text;

  if (props.liquidationType === 'HARD') {
    iconColor = 'text-cf-red-2' as const;
    text = 'Hard Liquidation';
  } else if (props.liquidationType === 'SOFT') {
    iconColor = 'text-cf-orange-2' as const;
    text = 'Soft Liquidation';
  } else if (props.liquidationType === 'SOFT_VOLUNTARY') {
    iconColor = 'text-cf-blue-4' as const;
    text = 'Manual Liquidation';
  } else {
    iconColor = 'text-cf-light-2' as const;
    text = 'Liquidation';
  }

  return (
    <Pill
      key="onchain"
      text={text}
      color="neutral"
      iconColor={iconColor}
      Icon={PulseIcon}
      {...props}
      maxWidth={false}
    />
  );
};

export const OnChainPill = (props: PillProps) => (
  <Pill key="onchain" text="Internal" color="neutral" iconColor="text-cf-light-3" {...props} />
);

export const CcmPill = (props: PillProps) => (
  <Pill color="neutral" text="CCM" Icon={DocIcon} {...props} />
);

export const BoostPill = ({ text, ...props }: PillProps & { text: string }) => (
  <Pill color="neutral" Icon={BoltIcon} iconColor="text-cf-pink-1" text={text} {...props} />
);

export const DcaPill = ({ chunks, ...props }: { chunks: string | number } & PillProps) => (
  <Pill
    color="neutral"
    text={`${chunks} chunks`}
    Icon={ChunksIcon}
    iconColor="text-cf-light-3"
    {...props}
  />
);

export const FokPill = (props: PillProps) => (
  <Pill
    color="neutral"
    text="Slippage Protection"
    Icon={ShieldTickIcon}
    iconColor="text-cf-light-3"
    {...props}
  />
);

export const BrokerPill = (props: PillProps) => (
  <Pill color="neutral" text="Broker" Icon={BrokerIcon} {...props} />
);

export const AffiliatePill = (props: PillProps) => (
  <Pill color="neutral" text="Affiliate" Icon={UsersIcon} {...props} />
);

export const TopStrategyPill = ({ type }: { type: 'popular' | 'volume' | 'apy' }) => {
  if (type === 'popular')
    return (
      <Pill text="Most Popular" color="neutral" Icon={FireIcon} iconColor="text-cf-orange-1" />
    );

  if (type === 'volume')
    return <Pill text="Most Volume" color="neutral" Icon={BoltIcon} iconColor="text-cf-blue-2" />;

  if (type === 'apy')
    return (
      <Pill text="Highest APY" color="neutral" Icon={PercentageIcon} iconColor="text-cf-blue-4" />
    );

  return null;
};
